export default class ChartOfAccounts {
    constructor() {
        this.id = "";
        this.name = "";
        this.isPublic = false;
        this.costCenterId = "";
    }
    update(data) {
        this.id = data.id;
        this.name = data.name;
        this.isPublic = data.isPublic;
        this.costCenterId = data.costCenterId;
    }
}
